import Grid from '@material-ui/core/Grid';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import FlightIcon from '@serko/zui-icons/es/FlightIcon';
import classNames from 'classnames';
import React, {  Dispatch, FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { ItineraryStatus } from '../../models/itinerary';
import { AppState } from '../../store/model';
import { combinationInit } from '../../store/reducers/itinerary/actions';
import { getStatus } from '../../store/reducers/itinerary/selectors';

interface OwnProps {
  fromCity?: string;
  toCity?: string;
  isLastRoute?: boolean;
}

interface StateProps {
  status?: ItineraryStatus;
}

interface DispatchProps {
  runInit: void;
}

interface CombinationRouteProps
  extends OwnProps,
    StateProps,
    DispatchProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const _CombinationRouteBase: FunctionComponent<CombinationRouteProps> = ({
  classes,
  fromCity,
  toCity,
  isLastRoute,
}) => {
  return (
    <Grid
      container
      className={classNames(classes.mainWarp, {
        [classes.borderBottom]: isLastRoute,
        [classes.lastWrapHeight]: isLastRoute,
      })}
    >
      <Grid container className={classes.iconWarp}>
        <FlightIcon color="inherit" id="Icon-FlightIcon" />
      </Grid>
      <Grid container className={classes.routeTextWarp}>
        <Typography className={classes.routeText}>
          {fromCity} to <br />
          {toCity}
        </Typography>
      </Grid>
    </Grid>
  );
};

const styles = (theme: Theme) => {
  return createStyles({
    mainWarp: {
      width: '140px',
      height: '233px',
      padding: theme.spacing.unit * 2,
      background: 'white',
      borderLeft: '1px #E0E0E0 solid',
      borderTop: '1px #E0E0E0 solid',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'inline-flex',
      boxSizing: 'border-box',
    },
    borderBottom: {
      borderBottom: '1px #E0E0E0 solid',
    },
    lastWrapHeight: {
      height: '234px',
    },
    iconWarp: {
      width: '24px',
      height: '24px',
      position: 'relative',
    },
    routeTextWarp: {
      flexDirection: 'column',
      display: 'flex',
      paddingTop: theme.spacing.unit,
    },
    routeText: {
      textAlign: 'center',
      color: 'rgba(0,0,0,0.87)',
      fontSize: '16px',
      fontFamily: 'Roboto Medium',
      fontWeight: 500,
      letterSpacing: 0.15,
      wordWrap: 'break-word',
    },
  });
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    status: getStatus(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  runInit: () => {
    dispatch(combinationInit());
  },
});

const enhance = compose<CombinationRouteProps, OwnProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  injectIntl,
);

export const CombinationRoute = enhance(_CombinationRouteBase);

CombinationRoute.displayName = 'CombinationRoute';
